import { atom } from "recoil";

export const getMasterSkillAtom = atom({
  key: "getMasterSkillAtom",
  default: [],
});

export const getMasterVersionUser = atom({
  key: "getMasterVersionUser",
  default: [],
});
